module.exports = __webpack_public_path__ + "img/BS16.0af1850b.svg";